import { Formik } from "formik";
import Loader from "../../components/loader";
import { useLocation, useNavigate } from "react-router-dom";
import AuthLayout from "../../layout/AuthLayout";
import { webPaths } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { forgotPasswordSchema } from "../../utils/schema";
import ErrorMessage from "../../components/forms/ErrorMessage";
import { authForgotPassword } from "../../redux/actions/authAction";
import useCountry from "../../components/hooks/useCountry";
import { buildAuthModalState } from "../../routes/authModal";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const countryData = useCountry();
  const { isLoading } = useSelector((state) => state.authReducer);
  const initialValues = {
    identifier: "",
  };

  const handleSignUp = async (values) => {
    const callback = (response) => {
      if (response.success)
        navigate(webPaths?.OtpVarification, {
          state: buildAuthModalState(location, {
            redirectFrom: webPaths?.ForgotPassword,
            identifier: values?.identifier,
          }),
        });
    };
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.identifier);

    const payload = {
      //  country: countryData?.country_name || "India",
      ...(isEmail
        ? { email: values.identifier }
        : { phone_no: `${countryData?.country_calling_code}${values.identifier}` }),
    };

     dispatch(
       authForgotPassword({
         payload,
         callback,
       }),
     );
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <AuthLayout>
        <div class="col-lg-12 mx-auto  login-popup__left ct_custom_scroll">
          <div>
            <div class="login-popup__brand mb-3">
              <img
                onClick={() => {
                  navigate(webPaths?.WebHome);
                }}
                style={{ cursor: "pointer" }}
                src="/assets/img/logo_black.png"
                class="main-logo"
                alt="SecurPoint"
              />
            </div>

            <h5 class="login-popup__title mb-2 ct_fs_28 text-center">
              Forgot Password
            </h5>
            <p class="ct_fs_15 ct_fw_500 text-center opacity-50 ct_switzer_Medium mb-0">
              Don’t worry it happens, please enter the email associated with
              your account.
            </p>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={forgotPasswordSchema}
            onSubmit={(values, actions) => {
              handleSignUp(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <div class="login-popup__roles">
                  <div class="">
                    <label class="mt-3 ct_fs_16 ct_fw_400 mb-2">
                      Email / Phone
                    </label>
                    <input
                      type="text"
                      class="form-control ct_input ct_login_input"
                      placeholder="Enter email / phone"
                      id="identifier"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.identifier}
                    />
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="identifier"
                    />
                  </div>
                </div>

                <button
                  class="btn mt-4 ct_green_bnt ct_white_nowrap w-100"
                  type="button"
                  onClick={() => {
                    // navigate(webPaths?.OtpVarification);
                    handleSubmit();
                  }}
                >
                  Submit
                </button>

                <p class="ct_fs_15 ct_fw_500 mt-3 text-center">
                  Already Know Your Password?
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(webPaths?.Login, {
                        state: buildAuthModalState(location),
                      });
                    }}
                    class="ct_fs_15 ct_fw_600 ct_green_text ct_cursor_pointer"
                  >
                    {" "}
                    Sign in
                  </a>
                </p>
              </form>
            )}
          </Formik>
        </div>
      </AuthLayout>
    </>
  );
};

export default ForgotPassword;
